export const isArrayofStrings = (value: any[]) => {
  return Array.isArray(value) && value.every(item => typeof item === 'string')
}
